import React from "react";

// Continent classification — by lat/lng with Middle-East carve-out.
// Used for the regional tabs that filter playlists across Home / My Feed / Profile.
export const REGION_TABS = ['Global', 'Americas', 'Asia', 'Africa', 'Europe', 'Oceania'];

export const getContinent = (location) => {
  if (!location || location.lat == null || location.lng == null) return 'Unknown';
  const lat = Number(location.lat);
  const lng = Number(location.lng);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return 'Unknown';

  if (lng >= -170 && lng <= -30) return 'Americas';

  if (lat <= 0 && lng >= 110 && lng <= 180) return 'Oceania';
  if (lat >= -50 && lat <= 30 && lng >= 170 && lng <= 180) return 'Oceania';
  if (lat >= -50 && lat <= 30 && lng >= -180 && lng <= -130) return 'Oceania';

  if (lat > 36 && lat <= 72 && lng >= -25 && lng <= 60) return 'Europe';

  if (lat >= -35 && lat <= 37 && lng >= -25 && lng <= 52) {
    if (lng >= 33 && lat >= 12) return 'Asia';
    return 'Africa';
  }

  if (lng >= 25 && lng <= 180 && lat >= -10 && lat <= 80) return 'Asia';

  return 'Unknown';
};

export const filterVideosByRegion = (videos, region) => {
  if (!region || region === 'Global') return videos;
  return (videos || []).filter(v => getContinent(v?.location) === region);
};

// Reusable region tabs strip
export const RegionTabs = ({ active, onChange, counts, testIdPrefix = 'region' }) => (
  <div
    className="inline-flex items-center gap-0.5 bg-gray-900/80 rounded-full px-1 py-0.5 border border-gray-800 max-w-full overflow-x-auto no-scrollbar"
    data-testid={`${testIdPrefix}-tabs`}
  >
    {REGION_TABS.map((r) => {
      const isActive = active === r;
      const count = counts ? counts[r] ?? 0 : null;
      const isDisabled = counts && r !== 'Global' && count === 0;
      return (
        <button
          key={r}
          type="button"
          onClick={() => !isDisabled && onChange(r)}
          disabled={isDisabled}
          data-testid={`${testIdPrefix}-tab-${r.toLowerCase()}`}
          className={`shrink-0 px-2 py-0.5 rounded-full text-[11px] font-medium transition-all whitespace-nowrap ${
            isActive
              ? 'bg-emerald-600 text-white shadow'
              : isDisabled
                ? 'text-gray-600 cursor-not-allowed'
                : 'text-gray-400 hover:text-white hover:bg-gray-800'
          }`}
          title={isDisabled ? `No videos in ${r}` : `Show ${r} videos`}
        >
          {r}
        </button>
      );
    })}
  </div>
);
